<template>
    <div class="container admin-submenu-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{ labels.title }}</h2>
        </div>
        <div class="admin-table-block mt-4" v-if="listaSubMenu?.length">
            <CorporateDataTable
                :items="submenusTableItems"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="crearSubMenu()">
                        {{ labels.add }}
                    </b-button>
                </template>
                <template #cell(id_menu_nombre)="data">
                    <div class="text-left">{{ data.item?.id_menu_nombre }}</div>
                </template>
                <template #cell(accionEdit)="data">
                    <b-button
                        style="background-color: #FF924C; width: 30px; height: 30px;"
                        class="md-fab md-primary table-action-btn"
                        @click="editSubMenu(data.item.id)"
                    >
                        <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                    </b-button>
                </template>
                <template #cell(accionInac)="data">
                    <b-button v-if="data.item?.estado == 1"
                        variant="link"
                        class="p-0 border-0 shadow-none table-action-btn"
                        @click="inactivar(data.item.id)"
                    >
                        <i><font-awesome-icon :icon="['fas', 'toggle-on']" size="xl"/></i>
                    </b-button>
                    <b-button v-else
                        variant="link"
                        class="p-0 border-0 shadow-none table-action-btn"
                        @click="activarSubMenu(data.item.id)"
                    >
                        <i><font-awesome-icon :icon="['fas', 'toggle-off']" size="xl"/></i>
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="admin-table-block mt-4" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <CrearSubmenu 
            :modCrearSubmenu="modCrearSubMenu" 
            @cierraModal="cierraModal"
            @created="recargarSubmenus"
        />
        <EditarSubmenu 
            :modEditarSubmenu="modEditarSubMenu" 
            :item="infoSubmenu" 
            @cierraModal="cierraModal"
            @updated="actualizarSubmenuEnLista"
        />
        <InacticaItem :InactivaItem="modInactivaSubMenu" @cierraModal="cierraModal" @confirmDelete="inactivaSubMenu"></InacticaItem>
    </div>
</template>

<script>
import Menu from '../../../services/Menu'
import SubMenu from '../../../services/SubMenu'
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import CrearSubmenu from './CrearSubmenu.vue'
import EditarSubmenu from './EditarSubmenu.vue'
import InacticaItem from '../../utils/InacticaItem.vue'

export default {
    name:'submenus',
    data: () => ({
        listaMenu: [],
        listaSubMenu: [],
        modCrearSubMenu: false,
        modEditarSubMenu: false,
        modInactivaSubMenu: false,
        infoSubmenu: [],
        idMenuInac: ""
    }),
    components:{
        CrearSubmenu,
        EditarSubmenu,
        InacticaItem,
        CorporateDataTable
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Submenus',
                    nombre  : "Nombre",
                    descripcion : "Descripción",
                    menu : "Menú",
                    editar : "Editar",
                    inactivar : "Inactivar",
                    estado : "Estado",
                    orden : "Orden",
                    add: "Añadir submenú",
                    noRow: "No hay registros",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterName: "Filtrar nombre...",
                    filterDescription: "Filtrar descripción..."
                }
            }
            return {
                title : 'Submenus',
                nombre  : "Name",
                descripcion : "Description",
                menu : "Menu",
                editar : "Edit",
                inactivar : "Inactivate",
                estado : "Status",
                orden : "Order",
                add: "Add submenu",
                noRow: "There are not records",
                noMatches: "No results found",
                searchPlaceholder: "Search in table...",
                rowsPerPage: "Rows per page:",
                noSort: "No sorting",
                sortAsc: "A-Z / Low to high",
                sortDesc: "Z-A / High to low",
                columns: "Columns",
                showAllColumns: "Show all",
                filters: "Filters",
                clearFilters: "Clear filters",
                filterName: "Filter name...",
                filterDescription: "Filter description..."
            }
        },
        submenusTableItems(){
            return (this.listaSubMenu || []).map((item) => ({
                ...item,
                id_menu_nombre: this.nameMenu(item?.id_menu)
            }))
        },
        allFields(){
            return [
                { key: 'nombre', label: this.labels.nombre, sortable: true },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true },
                { key: 'id_menu_nombre', label: this.labels.menu, sortable: true },
                { key: 'orden', label: this.labels.orden, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'accionEdit', label: this.labels.editar, thClass: 'text-center', tdClass: 'text-center', sortable: false },
                { key: 'accionInac', label: this.labels.estado, thClass: 'text-center', tdClass: 'text-center', sortable: false }
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'nombre', type: 'text', placeholder: this.labels.filterName },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescription }
            ]
        },
        tableLabels(){
            return {
                noRow: this.labels.noRow,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        cierraModal(val){
            this.modCrearSubMenu = val
            this.modEditarSubMenu = val
            this.modInactivaSubMenu = val
            if (!val) {
                this.idMenuInac = ""
                this.infoSubmenu = []
            }
        },
        recargarSubmenus() {
            SubMenu.getAllSubMenu()
                .then((res) => {
                    this.listaSubMenu = res.data.listSubMenu
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error('Error al recargar submenús')
                })
        },
        actualizarSubmenuEnLista(datosActualizados) {
            this.listaSubMenu = this.listaSubMenu.map((submenu) => {
                if (submenu.id === datosActualizados.id) {
                    return {
                        ...submenu,
                        nombre: datosActualizados.nombre,
                        descripcion: datosActualizados.descripcion,
                        ruta: datosActualizados.ruta,
                        id_menu: datosActualizados.id_menu,
                        orden: datosActualizados.orden
                    }
                }
                return submenu
            })
        },
        nameMenu(idMenu){
            let nombreMenu = this.listaMenu.find((menu) => menu.id == idMenu )
            return nombreMenu?.nombre || ''
        },
        crearSubMenu(){
            this.modCrearSubMenu = true
        },
        editSubMenu(id){
            SubMenu.subMenuById(id)
            .then((res) => {
                this.infoSubmenu = res.data.dataSubMenu
                this.modEditarSubMenu = true
            })
            .catch((err) => {
                console.log(err)
                this.$toast.error('Error al obtener datos del submenú')
            })
        },
        inactivar(id){
            this.idMenuInac = id
            this.modInactivaSubMenu = true
        },
        inactivaSubMenu(){
            let info = {'id' : this.idMenuInac}
            SubMenu.inactivaSubmenu(info)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    this.modInactivaSubMenu = false
                    this.listaSubMenu = this.listaSubMenu.map((submenu) => (
                        submenu.id === this.idMenuInac ? { ...submenu, estado: 0 } : submenu
                    ))
                    this.idMenuInac = ""
                }
            })
            .catch((err) => {
                console.log(err)
                this.$toast.error(err.response?.data?.message || 'Error al inactivar el submenú')
                this.modInactivaSubMenu = false
            })
        },
        activarSubMenu(id){
            let info = {'id' : id}
            SubMenu.activarSubmenu(info)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    this.listaSubMenu = this.listaSubMenu.map((submenu) => (
                        submenu.id === id ? { ...submenu, estado: 1 } : submenu
                    ))
                }
            })
            .catch((err) => {
                console.log(err)
                this.$toast.error(err.response?.data?.message || 'Error al activar el submenú')
            })
        },
        cargarDatos(){
            Menu.getAllMenu()
            .then((res) => {
                this.listaMenu = res.data.listMenu
            })
            .catch((err) => {
                console.log(err)
                this.$toast.error('Error al cargar menús')
            })

            SubMenu.getAllSubMenu()
            .then((res) => {
                this.listaSubMenu = res.data.listSubMenu
            })
            .catch((err) => {
                console.log(err)
                this.$toast.error('Error al cargar submenús')
            })
        }
    },
    mounted(){
        this.cargarDatos()
    }
}
</script>